import { symbolKey } from '@/entities/symbol';
import { HIGHLIGHTED_PRICE_MAX_ITEMS } from '@/features/dashboard/constants/const';
import type { MarketApp, MarketApps, TileBigNumber } from '@/features/dashboard/types';

export const getWidgetAnimationIds = (widget: MarketApp) => {
  if ('type' in widget) {
    return new Set(widget.tiles.map(tile => tile.id));
  }
  return widget.id ? new Set([widget.id]) : new Set<string>();
};

export const buildUpdatedTabContent = (
  currentTabContent: MarketApps,
  widget: MarketApp
): MarketApps => {
  if (!('type' in widget)) {
    return [...currentTabContent, widget] as MarketApps;
  }

  if (!currentTabContent[0] || !('type' in currentTabContent[0])) {
    return [widget, ...currentTabContent] as MarketApps;
  }

  const first = currentTabContent[0] as MarketApp & { tiles: TileBigNumber[] };
  const existingKeys = new Set(first.tiles.map(t => symbolKey(t.symbol.key)));
  const newTiles = widget.tiles.filter(t => !existingKeys.has(symbolKey(t.symbol.key)));
  const mergedTiles = [...first.tiles, ...newTiles].slice(0, HIGHLIGHTED_PRICE_MAX_ITEMS);

  return [{ ...first, tiles: mergedTiles }, ...currentTabContent.slice(1)] as MarketApps;
};
